import PropTypes from 'prop-types'
import { Box, Checkbox, HStack, Text, VStack } from '@chakra-ui/react'
import React from 'react'
import Selector from '../Selector/Selector'
import { REPOSITORY } from '../../api/repository/Repository'
import { numberFormat } from '../../utils/formats/formats'

export default function RefillsConfirmation({
  ammount,
  accounts,
  assign,
  handleAssign,
  notify,
  handleNotify,
}) {
  const { sCentroCosto } = REPOSITORY.local.company.getCompanyData()
  return (
    <VStack w="100%">
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text>Monto a recargar</Text>
        </Box>
        <Box>
          <Text>{numberFormat(ammount, 'currency')}</Text>
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text>Cantidad de cuentas</Text>
        </Box>
        <Box>
          <Text>{accounts}</Text>
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text>Asignar a centro de costo</Text>
        </Box>
        <Box w="50%">
          <Selector
            placeholder="Todos"
            onChange={handleAssign}
            options={sCentroCosto.slice(0, -1)}
            isClearable
            defaultValue={sCentroCosto.find((el) => el.id === assign)}
          />
        </Box>
      </HStack>
      <HStack justifyContent="space-between" w="100%">
        <Box>
          <Text>¿Notificar a colaboradores?</Text>
        </Box>
        <Box>
          <Checkbox isChecked={notify} onChange={handleNotify} />
        </Box>
      </HStack>
    </VStack>
  )
}

RefillsConfirmation.propTypes = {
  accounts: PropTypes.number,
  ammount: PropTypes.string,
  assign: PropTypes.object,
  handleAssign: PropTypes.func,
  handleNotify: PropTypes.func,
  notify: PropTypes.bool,
}
